import React from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Card, Typography, Stack } from "@mui/material";
import { ga } from "react-ga";

function AppConversionRates(props) {
  // Calculate percentages for count from props.generalAB.total
  const countPercentages = props.age.count.map(count => 
    props.ab.total_12_month ? ((count / props.ab.total_12_month) * 100).toFixed(1) : 0
  );
  console.log("Count :", props.age.count);
  console.log("Count Percentages:", countPercentages);
  // Calculate percentages for patients from sum of all patients
  const totalPatients = props.age.patients.reduce((sum, patients) => sum + patients, 0);
  const patientPercentages = props.age.patients.map(patients => 
    totalPatients ? ((patients / totalPatients) * 100).toFixed(1) : 0
  );

  const CHART_DATA = [
    {
      name: "Antibiotics prescriptions by age group",
      data: countPercentages,
      color: "#4f9ea9", // Blue
    },
    {
      name: "Second column gives a breakdown of the patient population for comparison.",
      data: patientPercentages,
      color: "#762D9E", // Purple
    },
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      stacked: false,
      toolbar: { show: false },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val}%`,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "70%",
        dataLabels: {
          position: "top",
        },
        distributed: false,
        borderRadius: 6,
        borderRadiusApplication: "end",
      },
    },
    stroke: {
      show: true,
      width: 8,
      colors: ['transparent']  // This creates space between bars
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val}%`,
      style: {
        colors: ["#22577A"],
        fontWeight: "bold",
      },
      offsetY: -20,
    },
    xaxis: {
      categories: ["<1", "1-6", "7-17", "18-29", "30-49", "50-69", ">=70"],
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      labels: {
        show: false, // Hides Y-axis labels
      },
    },
    grid: {
      show: false, // Removes grid lines
    },
    legend: {
      show: false, // Removes legend
    },
    colors: CHART_DATA.map((d) => d.color),
  };

  return (
    <Card sx={{ boxShadow: "none", p: 3 }}>
      <Typography variant="h4" sx={{ color: "#22577A", fontWeight: "bold", mb: 1 }}>
        Demographics
      </Typography>
      <Typography variant="subtitle1" sx={{ marginLeft:2, color: "#22577A", fontWeight: "bold" }}>
        Age
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ marginLeft:2,  mb: 1 }}>
        <Box sx={{ width: 15, height: 15, bgcolor: "#4f9ea9", borderRadius: 0 }} />
        <Typography variant="body2" color="textPrimary">
          Antibiotics prescriptions by age group
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ marginLeft:2,  mb: 2 }}>
        <Box sx={{ width: 15, height: 15, bgcolor: "#762D9E", borderRadius: 0 }} />
        <Typography variant="body2" color="textPrimary">
          Second column gives a breakdown of the patient population for comparison.
        </Typography>
      </Stack>
      <Box sx={{ mx: 1, borderRadius: 0 }} dir="ltr">
        <ReactApexChart type="bar" series={CHART_DATA} options={chartOptions} height={400} />
      </Box>
    </Card>
  );
}


import { connect } from "react-redux";
const mapState = state => ({
  age: state.antibiotics.age,
  ab: state.antibiotics.ab,
  user: state.user
});

const mapDispatch = ({
  antibiotics: { getGeneralAB }
}) => ({
  getGeneralAB: () => getGeneralAB()
});

export default connect(mapState, mapDispatch)(AppConversionRates);
